import { createContext } from 'react';

const AppTokenContext = createContext(null);

const AppTokenProvider = AppTokenContext.Provider;
const AppTokenConsumer = AppTokenContext.Consumer;

export { AppTokenContext, AppTokenProvider, AppTokenConsumer };